import React, { Component, PropTypes } from 'react';

import Tier from 'Tier/Tier';

export default class TieredSearchResultList extends Component {

  static propTypes = {
    tiers: PropTypes.array.isRequired
  };

  render() {
    const { tiers } = this.props;

    return (
      <div>
        {
          tiers.map((tier, tierIndex) => (
            tier.jobs.length > 0 &&
              <div key={tierIndex}>
                <Tier tierNumber={tierIndex + 1} header={tier.header} jobs={tier.jobs} />
              </div>
          ))
        }
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/TieredSearchResultList/TieredSearchResultList.js
 **/